import React, { useEffect } from 'react';
import { registerSvgIconCacheServiceWorker } from '$/utils/registerSvgIconCacheServiceWorker';

/**
 * 应用根级挂载：生产环境注册 IconFont SVG 缓存 Service Worker，对路由树无 UI 影响。
 */
function SvgIconServiceWorkerRegistrar() {
  useEffect(() => {
    registerSvgIconCacheServiceWorker();
  }, []);

  return null;
}

export default SvgIconServiceWorkerRegistrar;
